<template>
    <div class="">
        <p class="heading" v-if="collections && collections.length">What to wear</p>
        <ul class="brands-list" v-if="collections && collections.length">
            <li v-for="collection in collections" :key="collection.id">
                <a v-on:click="handleOnCollectionClick(collection)">{{ collection.name }}</a>
            </li>
        </ul>
        <p class="heading">Brands we love right now</p>
        <ul class="brands-list">
            <li v-for="brand in brands" :key="brand.product_brand_id">
                <a v-on:click="handleOnBrandClick(brand)">{{ brand.product_brand_title }}</a>
            </li>
        </ul>
        <div class="cta">
            <button v-on:click="handleCtaClick()">See All Brands</button>
        </div>
    </div>
</template>

<script>
import Mixins from "../../mixins/mixins.js";

export default {
    props: {
        brands: Array,
        collections: Array,
        handleOnCollectionClick: Function,
        handleOnBrandClick: Function,
        handleCtaClick: Function,
    },
    components: {},
    mixins: [Mixins],
    data() {
        return {};
    },
    computed: {},
    methods: {},
    mounted() {},
};
</script>

<style lang="scss" scoped>
.heading {
    font-size: 18px;
    font-weight: bold;
    margin: 10px 24px;
}

.brand-hero {
    width: 100%;
    padding: 0 10px;
}

.brands-list {
    border-top: 1px solid #f6f6f6;

    li {
        align-items: center;
        border-bottom: 1px solid #f6f6f6;
        display: flex;
        font-size: 14px;

        &:after {
            content: " ";
            display: block;
            width: 0;
            height: 0;
            border-top: 6px solid transparent;
            border-bottom: 6px solid transparent;
            border-left: 10px solid #000;
            margin-right: 20px;
        }
    }

    a {
        flex-grow: 1;
        padding: 14px 24px;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }
}

.cta {
    padding: 30px 20px;
    text-align: center;

    button {
        background: #000;
        border-radius: 23px;
        color: #fff;
        font-size: 14px;
        padding: 10px;
        width: 220px;

        &:focus {
            outline: none;
        }
    }
}
</style>
